import React from 'react';
import { motion } from 'framer-motion';

const Founder = () => {
  return (
    <section id="founder" className="scroll-mt-24 bg-lotus-petal/20 px-6 py-20 lg:px-8 lg:py-28 overflow-hidden">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-12 lg:grid-cols-5 lg:gap-16">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="order-2 lg:order-1 lg:col-span-3"
          >
            <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
              Meet the Founder
            </span>
            <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
              Preeti Biswas
            </h2>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-lotus-deep/70 font-medium">
              Founder & CEO — Lotus Prana
            </p>
            <p className="mt-6 text-lg leading-relaxed text-lotus-ink/70">
              A certified Pranic Healer and meditation guide, Preeti founded Lotus Prana to bring the transformative practice of energy healing to individuals, families, and workplaces. Her work is grounded in compassion, integrity, and a lifelong commitment to holistic well-being.
            </p>
            <p className="mt-4 font-serif text-lg italic text-lotus-ink font-medium">
              "When individuals heal, families become stronger, workplaces become healthier, and communities flourish."
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30, scale: 0.95 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
            className="order-1 lg:order-2 lg:col-span-2"
          >
            <div className="aspect-[3/4] overflow-hidden rounded-3xl bg-lotus-petal/40 shadow-xl outline outline-1 -outline-offset-1 outline-lotus-ink/10 group">
              <img
                src="/images/preeti-biswas.webp"
                alt="Preeti Biswas, Founder and CEO of Lotus Prana"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
